module.exports = __webpack_public_path__ + "static/headshot-chris-long-2x.78bab3a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-chris-long-2x.jpg
// module id = 120
// module chunks = 35783957827783 152909308826437